import * as React from 'react'

import { UI } from 'components/_Assets/svg/Icon/ui'
import Icon from 'components/Icon'
import { DefaultContent } from 'react-content-engine'
import CodeEntry, { CodeEntryProps } from './CodeEntry'

interface Giftcard {
  code: string
  currency: string
  amount: number
  message?: React.ReactNode
}

interface GiftcardCodeEntryProps extends CodeEntryProps {
  giftcards: Giftcard[]
  onClickDelete: (code: string) => void
  currency?: string
  amount?: number
}

const GiftcardCodeEntry: React.FC<GiftcardCodeEntryProps> = props => {
  return (
    <div className="srprs-codeEntry size-s is-negative">
      <div className="added-cards">
        <ul>
          {props.giftcards.map(giftcard => {
            return (
              <li key={giftcard.code}>
                <DefaultContent contentKey="gift-card-value">
                  Gift card value
                </DefaultContent>
                {giftcard.currency} {giftcard.amount}
                {giftcard.message ? (
                  <>
                    <br />
                    <em>{giftcard.message}</em>
                  </>
                ) : (
                  ''
                )}
                <button onClick={() => props.onClickDelete(giftcard.code)}>
                  <Icon icon={UI.trash} />
                </button>
              </li>
            )
          })}
        </ul>
      </div>
      <CodeEntry negative giftcard numberOfCircles={6} {...props} />
      <footer>
        {props.amount ? (
          <i>
            {props.currency} {props.amount}
          </i>
        ) : (
          <i>?</i>
        )}
      </footer>
    </div>
  )
}

export default GiftcardCodeEntry
